module.exports = __webpack_public_path__ + "img/image_15.d2811a9b.png";